<template>
  <div class="card-type" :class="cardType">
    <div class="card-type-icon" v-bind:class="cardType"></div>
    {{ cardType.toUpperCase() }}
  </div>
</template>
<style scoped>
  .card-type {
    display: flex;
    margin-right: 8px;
  }
  .card-type-icon {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .card-type-icon.isic {
    background: #40b8b8;
  }

  .card-type.isic {
    color: #40b8b8;
  }

  .card-type.itic {
    color: #f37526;
  }

  .card-type-icon.itic {
    background: #f37526;
  }

  .card-type.iytc {
    color: #2c90dc;
  }

  .card-type-icon.iytc {
    background: #2c90dc;
}
</style>
<script>
export default {
  name: 'card-type',
  props: {
    cardType: {
      type: String,
      required: true,
    },
  },
};
</script>
